/// <amd-module name="Artifacts/Nuget/commands/Restore" />

import { NugetActions } from "Artifacts/Nuget/redux";
import { getRestoreCommandCreator } from "Artifacts/Root/protocols/Commands";

export const createRestoreCommand = getRestoreCommandCreator(NugetActions.restore);
